// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "4777" ? "monaco-editor" : chunkId) + "." + {"2067": "40e2b10f","3067": "08566aea","3573": "25e50ce7","3898": "e5b33855","4551": "d42829df","4777": "13f44d2c","5213": "a5e39a5d","665": "d8530b68",}[chunkId] + ".css"
}